import { FunctionComponent, useEffect, useState } from "react";
import styles from "../finishPayment/finishPayment.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useReCaptchaValidation } from "../../hook/useReCaptchaValidation";
import { ecommerceEvents } from "../../utils/gtm";
import { useCheckout } from "../../context/CheckoutContext";

const FinishPayment: FunctionComponent = ({disabled, paymentType}: { disabled: boolean, paymentType: string }) => {
  const navigate = useNavigate();

  const { 
    cart,
    clientAndAffiliate,
    purchaser,
    totalPrice,
    coupon,
    planName,
    planId,
    address
  } = useCheckout();

  const {
    isValidReCaptcha,
    validateReCaptcha,
  } = useReCaptchaValidation();

  const params = useParams()
  
  useEffect(() => {
    if(isValidReCaptcha) {
      
      ecommerceEvents.addPaymentInfo({
        currency: "BRL",
        value: totalPrice,
        shipping_tier: "free",
        coupon: coupon.name? coupon.name : "",
        email: purchaser.email,
        phone: purchaser.telephone.replace(/[()\-\s]/g, ''),
        first_name: purchaser.name,
        last_name: purchaser.lastname,
        afiliado: params.slug? params.slug : clientAndAffiliate.affiliate_id? clientAndAffiliate.affiliate_id : "",
        payment_type: paymentType,
        items: cart.map(item => ({
          item_id: item.id,
          item_name: item.name,
          price: item.price,
          quantity: item.quantity,
          promotion_id: planId,
          promotion_name: planName,
        })),
        shipping_address: {
          city: address.cidade,
          street: address.logradouro,
          number: address.numero,
          state: address.estado,
          neighborhood: address.bairro,
          postal_code: address.cep,
          complement: address.complemento,
        }
      });

      params.slug
        ? navigate(`/checkout-pagamento-processando/${params.slug}`)
        : navigate("/checkout-pagamento-processando");
    }
  }, [isValidReCaptcha])

  const handleSubmitForm = async () => {
    await validateReCaptcha();
  };

  return (
    <div
    className={disabled && paymentType === 'Cartão'? styles.disabledCarrinho : styles.cta1}
    onClick={disabled && paymentType === 'Cartão'? () => {} : handleSubmitForm}
    style={{borderRadius: 0}}
  >
    <div className={styles.yelly}>Finalizar compra</div>
  </div>
  );
};

export default FinishPayment;
